/* eslint-disable @typescript-eslint/no-explicit-any */
import { parseDateV2 } from '@cyren/common-lib';
import { InputMask } from '@react-input/mask';
import { InputHTMLAttributes, memo, useEffect, useState } from 'react';

import classNames from 'classnames';
import { differenceInYears } from 'date-fns';
import { useStaticLocales } from '../../../admin/hooks/locales/use-static-locale';
import Modal from '../../../components/Modal';
import { QuestionProps } from '../../pa-prop-types';

function QsInputDateDob(
  props: Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> &
    QuestionProps & {
      onChange: (value: string) => void;
    },
) {
  const {
    value,
    onChange,
    error,
    question,
    // className, error
  } = props;

  const { sltStr } = useStaticLocales();
  const localizedDatePlaceholder = sltStr({ key: 'mon-day-year' });
  const [dateInput, setDateInput] = useState(`${value || ''}`);
  const [age, setAge] = useState<number | null>(null);
  const ageRestriction = question?.typeOptions?.ageRestriction;
  const [blockByAge, setBlockByAge] = useState(false);

  useEffect(() => {
    setDateInput(`${value || ''}`);
  }, [value]);

  useEffect(() => {
    const validDate = parseDateV2({
      dateStr: dateInput,
      formatStr: 'MM/dd/yyyy',
    });

    if (validDate) {
      onChange(dateInput);

      if (ageRestriction) {
        const nAge = differenceInYears(new Date(), validDate);
        setAge(nAge);
      }
    } else {
      onChange('');
    }
  }, [dateInput, ageRestriction]);

  return (
    <div className='t_QsInputDateDob flex-col gap-3'>
      <div className='flex-col gap-1'>
        <InputMask
          separate
          className={classNames(
            'input tracking-widest w-[10rem] max-w-auto',
            error && 'input-error',
            'text-center'
          )}
          value={dateInput}
          onChange={(e) => {
            setDateInput(e.target.value);
          }}
          placeholder={localizedDatePlaceholder}
          pattern='[0-9]*'
          mask='99/99/9999'
          onBlur={() => {
            if (ageRestriction && age != null && (age === 0 || age < ageRestriction)) {
              setBlockByAge(true);
            }
          }}
          replacement={{ 9: /\d/ }}
          showMask={false}
        />
        <span className='text-xs opacity-70 px-4'>{sltStr({ key: 'mon-day-year' })} </span>
      </div>
      {blockByAge && (
        <Modal open className='lg:max-w-[58rem] xl:max-w-[64rem]'>
          <div
            className='flex flex-col justify-center items-center gap-7'
            onClick={() => setBlockByAge(false)}
          >
            <div className='text-2xl font-bold text-center'>Age restriction applied</div>
            <div className='text-center'>
              You MUST not use this app, if you are under {ageRestriction} years old.
              <br />
              Please close the app immediately.
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default memo(QsInputDateDob);
